export default "__VITE_ASSET__8a083537__"